import { default as aboutEzmx28AGPGMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue?macro=true";
import { default as eventsqleTFDRSvYMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93bPpdMsq0a6Meta } from "/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sample7OuRxxDIhiMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productssBjBYM5Zx0Meta } from "/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93i2xRir9f95Meta } from "/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewggkJcNlb4vMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexcqjKYJlLW1Meta } from "/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93QTzfkTGiDnMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as index7Q15wuVZ6FMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93vGbIY8cQtfMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexLuqArhhlVyMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsIt8j83uixCMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsd8AT07Moi7Meta } from "/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsWHojvNeY2hMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93BtmmT5muObMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue?macro=true";
import { default as indexPrqIYEPWnQMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/buy/product/[product_id]/index.vue?macro=true";
import { default as confirmpmmvTraM41Meta } from "/tmp/build_b5bbee9d/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue?macro=true";
import { default as confirmSLHFfCsSqvMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue?macro=true";
import { default as calendart3oGsopeUVMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/calendar.vue?macro=true";
import { default as chatAtUODyavdmMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/chat.vue?macro=true";
import { default as about1LgirELkXRMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/community-groups/[group_id]/about.vue?macro=true";
import { default as feedUlrJKuPlAmMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/community-groups/[group_id]/feed.vue?macro=true";
import { default as members3t6HT99zfbMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/community-groups/[group_id]/members.vue?macro=true";
import { default as _91group_id_93DQeoCGaBm4Meta } from "/tmp/build_b5bbee9d/pages/[studio_url]/community-groups/[group_id].vue?macro=true";
import { default as community_45profile_45edit7F47HqprLyMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/community-profile-edit.vue?macro=true";
import { default as _91id_938xVLpZvDyWMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/community-profile/[id].vue?macro=true";
import { default as community0Lk3cUN0FUMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/community.vue?macro=true";
import { default as _91uuid_93h46N7zs1fEMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/complete-registration/[uuid].vue?macro=true";
import { default as _91unique_id_93UYBRTrVJWMMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/contracts/[unique_id].vue?macro=true";
import { default as dashboardDMKxYOoYngMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/dashboard.vue?macro=true";
import { default as indexANLLzvXfQZMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/event/details/[event_id]/index.vue?macro=true";
import { default as checkoutQbekMTMm7PMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue?macro=true";
import { default as select_45productA03U31KIffMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/event/details/[event_id]/select-product.vue?macro=true";
import { default as events5YoaxW1sAmMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/events.vue?macro=true";
import { default as _91uuid_93IDyG29oep1Meta } from "/tmp/build_b5bbee9d/pages/[studio_url]/gifts/[uuid].vue?macro=true";
import { default as indexaCrdwxXKNXMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/gifts/index.vue?macro=true";
import { default as _91invitation_id_93WjspYtc6iEMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/gifts/invitation/[invitation_id].vue?macro=true";
import { default as _91product_id_93k5SLgNJYLuMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/gifts/product/[product_id].vue?macro=true";
import { default as indexXHBjz7wYeSMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/index.vue?macro=true";
import { default as _91invitation_unique_id_93FyfigtTdTcMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/invitation/[invitation_unique_id].vue?macro=true";
import { default as joinSE9yISEi0kMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/join.vue?macro=true";
import { default as login3tB2WDCkfOMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/login.vue?macro=true";
import { default as logoutzMjzzXpcAeMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/logout.vue?macro=true";
import { default as _91meeting_type_slug_93FZA77WTp3BMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/meet/[meeting_type_slug].vue?macro=true";
import { default as _91meeting_unique_id_93zmXWtjROmlMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/meet/[meeting_unique_id].vue?macro=true";
import { default as _91meeting_unique_id_93FdmxMYa9K9Meta } from "/tmp/build_b5bbee9d/pages/[studio_url]/meeting/[meeting_unique_id].vue?macro=true";
import { default as my_45favoritesDhiPb5S1bgMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/my-favorites.vue?macro=true";
import { default as my_45studiosdldqDB6zwUMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/my-studios.vue?macro=true";
import { default as optinmKLWxXyr7RMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/optin.vue?macro=true";
import { default as _91episode_id_93akjyir9FJZMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue?macro=true";
import { default as indexISbOpBoVxGMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/podcasts/[podcast_id]/index.vue?macro=true";
import { default as index1aGRqnXKz0Meta } from "/tmp/build_b5bbee9d/pages/[studio_url]/podcasts/index.vue?macro=true";
import { default as abouts563UZgXcMMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/about.vue?macro=true";
import { default as digital_45download_45contentLSoxlXRF8TMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/digital-download-content.vue?macro=true";
import { default as eventsCF8fPhCj6SMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93jA3HLRpUExMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sample0JDGB0sJnpMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsIerZ8N8BGBMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93q9VUbYM5FlMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as view5C6bzcETEnMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indextWWLWL6uI5Meta } from "/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93WMh4oSTSSUMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexIeGmuNwCa5Meta } from "/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93ZoVXRcyOigMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexRXTstQ1RRoMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsNMjTq8nTCJMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsGdLH5CvPcrMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsUzdjHfJqfKMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_933hn8GCyqCAMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id].vue?macro=true";
import { default as indexidNo0CbkiHMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/product/index.vue?macro=true";
import { default as indexaqR0BUg2TgMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/profile/index.vue?macro=true";
import { default as purchasesyk1fo2tlyjMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/profile/purchases.vue?macro=true";
import { default as redemptionsF2WlTsaLORMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/profile/redemptions.vue?macro=true";
import { default as _91quiz_id_93xFRibBwJDsMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/quiz/[quiz_id].vue?macro=true";
import { default as _91token_93R6t244Zaq4Meta } from "/tmp/build_b5bbee9d/pages/[studio_url]/reset-password/[uid]/[token].vue?macro=true";
import { default as resetbFElebpWOtMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/reset.vue?macro=true";
import { default as shopXuM9FK4QYeMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/shop.vue?macro=true";
import { default as signupv76RDVr3aXMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/signup.vue?macro=true";
import { default as liveX2TB1qcnxsMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/streaming/[event_id]/live.vue?macro=true";
import { default as tipsDfRfoIHc0cMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/tips.vue?macro=true";
import { default as _91uuid_93lJxQ6r5eMTMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/waiver/[uuid].vue?macro=true";
import { default as compactMhNp1iPZHCMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/widgets/calendars/compact.vue?macro=true";
import { default as full9YOWqpyVHPMeta } from "/tmp/build_b5bbee9d/pages/[studio_url]/widgets/calendars/full.vue?macro=true";
export default [
  {
    name: _91product_id_93BtmmT5muObMeta?.name ?? "bundle-bundle_id-product-product_id",
    path: _91product_id_93BtmmT5muObMeta?.path ?? "/bundle/:bundle_id()/product/:product_id()",
    meta: _91product_id_93BtmmT5muObMeta || {},
    alias: _91product_id_93BtmmT5muObMeta?.alias || [],
    redirect: _91product_id_93BtmmT5muObMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutEzmx28AGPGMeta?.name ?? "bundle-bundle_id-product-product_id-about",
    path: aboutEzmx28AGPGMeta?.path ?? "about",
    meta: aboutEzmx28AGPGMeta || {},
    alias: aboutEzmx28AGPGMeta?.alias || [],
    redirect: aboutEzmx28AGPGMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: eventsqleTFDRSvYMeta?.name ?? "bundle-bundle_id-product-product_id-events",
    path: eventsqleTFDRSvYMeta?.path ?? "events",
    meta: eventsqleTFDRSvYMeta || {},
    alias: eventsqleTFDRSvYMeta?.alias || [],
    redirect: eventsqleTFDRSvYMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93bPpdMsq0a6Meta?.name ?? "bundle-bundle_id-product-product_id-free-media-media_id",
    path: _91media_id_93bPpdMsq0a6Meta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93bPpdMsq0a6Meta || {},
    alias: _91media_id_93bPpdMsq0a6Meta?.alias || [],
    redirect: _91media_id_93bPpdMsq0a6Meta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sample7OuRxxDIhiMeta?.name ?? "bundle-bundle_id-product-product_id-free-sample",
    path: free_45sample7OuRxxDIhiMeta?.path ?? "free-sample",
    meta: free_45sample7OuRxxDIhiMeta || {},
    alias: free_45sample7OuRxxDIhiMeta?.alias || [],
    redirect: free_45sample7OuRxxDIhiMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productssBjBYM5Zx0Meta?.name ?? "bundle-bundle_id-product-product_id-included-products",
    path: included_45productssBjBYM5Zx0Meta?.path ?? "included-products",
    meta: included_45productssBjBYM5Zx0Meta || {},
    alias: included_45productssBjBYM5Zx0Meta?.alias || [],
    redirect: included_45productssBjBYM5Zx0Meta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93i2xRir9f95Meta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93i2xRir9f95Meta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93i2xRir9f95Meta || {},
    alias: _91media_id_93i2xRir9f95Meta?.alias || [],
    redirect: _91media_id_93i2xRir9f95Meta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewggkJcNlb4vMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-view",
    path: viewggkJcNlb4vMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewggkJcNlb4vMeta || {},
    alias: viewggkJcNlb4vMeta?.alias || [],
    redirect: viewggkJcNlb4vMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexcqjKYJlLW1Meta?.name ?? "bundle-bundle_id-product-product_id-lessons",
    path: indexcqjKYJlLW1Meta?.path ?? "lessons",
    meta: indexcqjKYJlLW1Meta || {},
    alias: indexcqjKYJlLW1Meta?.alias || [],
    redirect: indexcqjKYJlLW1Meta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93QTzfkTGiDnMeta?.name ?? "bundle-bundle_id-product-product_id-media-media_id",
    path: _91media_id_93QTzfkTGiDnMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93QTzfkTGiDnMeta || {},
    alias: _91media_id_93QTzfkTGiDnMeta?.alias || [],
    redirect: _91media_id_93QTzfkTGiDnMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: index7Q15wuVZ6FMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id",
    path: index7Q15wuVZ6FMeta?.path ?? "playlists/:playlist_id()",
    meta: index7Q15wuVZ6FMeta || {},
    alias: index7Q15wuVZ6FMeta?.alias || [],
    redirect: index7Q15wuVZ6FMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93vGbIY8cQtfMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93vGbIY8cQtfMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93vGbIY8cQtfMeta || {},
    alias: _91media_id_93vGbIY8cQtfMeta?.alias || [],
    redirect: _91media_id_93vGbIY8cQtfMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexLuqArhhlVyMeta?.name ?? "bundle-bundle_id-product-product_id-playlists",
    path: indexLuqArhhlVyMeta?.path ?? "playlists",
    meta: indexLuqArhhlVyMeta || {},
    alias: indexLuqArhhlVyMeta?.alias || [],
    redirect: indexLuqArhhlVyMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsIt8j83uixCMeta?.name ?? "bundle-bundle_id-product-product_id-private-sessions",
    path: private_45sessionsIt8j83uixCMeta?.path ?? "private-sessions",
    meta: private_45sessionsIt8j83uixCMeta || {},
    alias: private_45sessionsIt8j83uixCMeta?.alias || [],
    redirect: private_45sessionsIt8j83uixCMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsd8AT07Moi7Meta?.name ?? "bundle-bundle_id-product-product_id-recordings",
    path: recordingsd8AT07Moi7Meta?.path ?? "recordings",
    meta: recordingsd8AT07Moi7Meta || {},
    alias: recordingsd8AT07Moi7Meta?.alias || [],
    redirect: recordingsd8AT07Moi7Meta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsWHojvNeY2hMeta?.name ?? "bundle-bundle_id-product-product_id-reviews",
    path: reviewsWHojvNeY2hMeta?.path ?? "reviews",
    meta: reviewsWHojvNeY2hMeta || {},
    alias: reviewsWHojvNeY2hMeta?.alias || [],
    redirect: reviewsWHojvNeY2hMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexPrqIYEPWnQMeta?.name ?? "buy-product-product_id",
    path: indexPrqIYEPWnQMeta?.path ?? "/buy/product/:product_id()",
    meta: indexPrqIYEPWnQMeta || {},
    alias: indexPrqIYEPWnQMeta?.alias || [],
    redirect: indexPrqIYEPWnQMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/buy/product/[product_id]/index.vue").then(m => m.default || m)
  },
  {
    name: confirmpmmvTraM41Meta?.name ?? "buy-product-product_id-paypal-confirm",
    path: confirmpmmvTraM41Meta?.path ?? "/buy/product/:product_id()/paypal/confirm",
    meta: confirmpmmvTraM41Meta || {},
    alias: confirmpmmvTraM41Meta?.alias || [],
    redirect: confirmpmmvTraM41Meta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue").then(m => m.default || m)
  },
  {
    name: confirmSLHFfCsSqvMeta?.name ?? "buy-product-product_id-stripe-confirm",
    path: confirmSLHFfCsSqvMeta?.path ?? "/buy/product/:product_id()/stripe/confirm",
    meta: confirmSLHFfCsSqvMeta || {},
    alias: confirmSLHFfCsSqvMeta?.alias || [],
    redirect: confirmSLHFfCsSqvMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue").then(m => m.default || m)
  },
  {
    name: calendart3oGsopeUVMeta?.name ?? "calendar",
    path: calendart3oGsopeUVMeta?.path ?? "/calendar",
    meta: calendart3oGsopeUVMeta || {},
    alias: calendart3oGsopeUVMeta?.alias || [],
    redirect: calendart3oGsopeUVMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/calendar.vue").then(m => m.default || m)
  },
  {
    name: chatAtUODyavdmMeta?.name ?? "chat",
    path: chatAtUODyavdmMeta?.path ?? "/chat",
    meta: chatAtUODyavdmMeta || {},
    alias: chatAtUODyavdmMeta?.alias || [],
    redirect: chatAtUODyavdmMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/chat.vue").then(m => m.default || m)
  },
  {
    name: _91group_id_93DQeoCGaBm4Meta?.name ?? "community-groups-group_id",
    path: _91group_id_93DQeoCGaBm4Meta?.path ?? "/community-groups/:group_id()",
    meta: _91group_id_93DQeoCGaBm4Meta || {},
    alias: _91group_id_93DQeoCGaBm4Meta?.alias || [],
    redirect: _91group_id_93DQeoCGaBm4Meta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/community-groups/[group_id].vue").then(m => m.default || m),
    children: [
  {
    name: about1LgirELkXRMeta?.name ?? "community-groups-group_id-about",
    path: about1LgirELkXRMeta?.path ?? "about",
    meta: about1LgirELkXRMeta || {},
    alias: about1LgirELkXRMeta?.alias || [],
    redirect: about1LgirELkXRMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/community-groups/[group_id]/about.vue").then(m => m.default || m)
  },
  {
    name: feedUlrJKuPlAmMeta?.name ?? "community-groups-group_id-feed",
    path: feedUlrJKuPlAmMeta?.path ?? "feed",
    meta: feedUlrJKuPlAmMeta || {},
    alias: feedUlrJKuPlAmMeta?.alias || [],
    redirect: feedUlrJKuPlAmMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/community-groups/[group_id]/feed.vue").then(m => m.default || m)
  },
  {
    name: members3t6HT99zfbMeta?.name ?? "community-groups-group_id-members",
    path: members3t6HT99zfbMeta?.path ?? "members",
    meta: members3t6HT99zfbMeta || {},
    alias: members3t6HT99zfbMeta?.alias || [],
    redirect: members3t6HT99zfbMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/community-groups/[group_id]/members.vue").then(m => m.default || m)
  }
]
  },
  {
    name: community_45profile_45edit7F47HqprLyMeta?.name ?? "community-profile-edit",
    path: community_45profile_45edit7F47HqprLyMeta?.path ?? "/community-profile-edit",
    meta: community_45profile_45edit7F47HqprLyMeta || {},
    alias: community_45profile_45edit7F47HqprLyMeta?.alias || [],
    redirect: community_45profile_45edit7F47HqprLyMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/community-profile-edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_938xVLpZvDyWMeta?.name ?? "community-profile-id",
    path: _91id_938xVLpZvDyWMeta?.path ?? "/community-profile/:id()",
    meta: _91id_938xVLpZvDyWMeta || {},
    alias: _91id_938xVLpZvDyWMeta?.alias || [],
    redirect: _91id_938xVLpZvDyWMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/community-profile/[id].vue").then(m => m.default || m)
  },
  {
    name: community0Lk3cUN0FUMeta?.name ?? "community",
    path: community0Lk3cUN0FUMeta?.path ?? "/community",
    meta: community0Lk3cUN0FUMeta || {},
    alias: community0Lk3cUN0FUMeta?.alias || [],
    redirect: community0Lk3cUN0FUMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/community.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93h46N7zs1fEMeta?.name ?? "complete-registration-uuid",
    path: _91uuid_93h46N7zs1fEMeta?.path ?? "/complete-registration/:uuid()",
    meta: _91uuid_93h46N7zs1fEMeta || {},
    alias: _91uuid_93h46N7zs1fEMeta?.alias || [],
    redirect: _91uuid_93h46N7zs1fEMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/complete-registration/[uuid].vue").then(m => m.default || m)
  },
  {
    name: _91unique_id_93UYBRTrVJWMMeta?.name ?? "contracts-unique_id",
    path: _91unique_id_93UYBRTrVJWMMeta?.path ?? "/contracts/:unique_id()",
    meta: _91unique_id_93UYBRTrVJWMMeta || {},
    alias: _91unique_id_93UYBRTrVJWMMeta?.alias || [],
    redirect: _91unique_id_93UYBRTrVJWMMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/contracts/[unique_id].vue").then(m => m.default || m)
  },
  {
    name: dashboardDMKxYOoYngMeta?.name ?? "dashboard",
    path: dashboardDMKxYOoYngMeta?.path ?? "/dashboard",
    meta: dashboardDMKxYOoYngMeta || {},
    alias: dashboardDMKxYOoYngMeta?.alias || [],
    redirect: dashboardDMKxYOoYngMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/dashboard.vue").then(m => m.default || m)
  },
  {
    name: indexANLLzvXfQZMeta?.name ?? "event-details-event_id",
    path: indexANLLzvXfQZMeta?.path ?? "/event/details/:event_id()",
    meta: indexANLLzvXfQZMeta || {},
    alias: indexANLLzvXfQZMeta?.alias || [],
    redirect: indexANLLzvXfQZMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/event/details/[event_id]/index.vue").then(m => m.default || m)
  },
  {
    name: checkoutQbekMTMm7PMeta?.name ?? "event-details-event_id-product-product_id-checkout",
    path: checkoutQbekMTMm7PMeta?.path ?? "/event/details/:event_id()/product/:product_id()/checkout",
    meta: checkoutQbekMTMm7PMeta || {},
    alias: checkoutQbekMTMm7PMeta?.alias || [],
    redirect: checkoutQbekMTMm7PMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue").then(m => m.default || m)
  },
  {
    name: select_45productA03U31KIffMeta?.name ?? "event-details-event_id-select-product",
    path: select_45productA03U31KIffMeta?.path ?? "/event/details/:event_id()/select-product",
    meta: select_45productA03U31KIffMeta || {},
    alias: select_45productA03U31KIffMeta?.alias || [],
    redirect: select_45productA03U31KIffMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/event/details/[event_id]/select-product.vue").then(m => m.default || m)
  },
  {
    name: events5YoaxW1sAmMeta?.name ?? "events",
    path: events5YoaxW1sAmMeta?.path ?? "/events",
    meta: events5YoaxW1sAmMeta || {},
    alias: events5YoaxW1sAmMeta?.alias || [],
    redirect: events5YoaxW1sAmMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/events.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93IDyG29oep1Meta?.name ?? "gifts-uuid",
    path: _91uuid_93IDyG29oep1Meta?.path ?? "/gifts/:uuid()",
    meta: _91uuid_93IDyG29oep1Meta || {},
    alias: _91uuid_93IDyG29oep1Meta?.alias || [],
    redirect: _91uuid_93IDyG29oep1Meta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/gifts/[uuid].vue").then(m => m.default || m)
  },
  {
    name: indexaCrdwxXKNXMeta?.name ?? "gifts",
    path: indexaCrdwxXKNXMeta?.path ?? "/gifts",
    meta: indexaCrdwxXKNXMeta || {},
    alias: indexaCrdwxXKNXMeta?.alias || [],
    redirect: indexaCrdwxXKNXMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/gifts/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_id_93WjspYtc6iEMeta?.name ?? "gifts-invitation-invitation_id",
    path: _91invitation_id_93WjspYtc6iEMeta?.path ?? "/gifts/invitation/:invitation_id()",
    meta: _91invitation_id_93WjspYtc6iEMeta || {},
    alias: _91invitation_id_93WjspYtc6iEMeta?.alias || [],
    redirect: _91invitation_id_93WjspYtc6iEMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/gifts/invitation/[invitation_id].vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93k5SLgNJYLuMeta?.name ?? "gifts-product-product_id",
    path: _91product_id_93k5SLgNJYLuMeta?.path ?? "/gifts/product/:product_id()",
    meta: _91product_id_93k5SLgNJYLuMeta || {},
    alias: _91product_id_93k5SLgNJYLuMeta?.alias || [],
    redirect: _91product_id_93k5SLgNJYLuMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/gifts/product/[product_id].vue").then(m => m.default || m)
  },
  {
    name: indexXHBjz7wYeSMeta?.name ?? "index",
    path: indexXHBjz7wYeSMeta?.path ?? "/",
    meta: indexXHBjz7wYeSMeta || {},
    alias: indexXHBjz7wYeSMeta?.alias || [],
    redirect: indexXHBjz7wYeSMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_unique_id_93FyfigtTdTcMeta?.name ?? "invitation-invitation_unique_id",
    path: _91invitation_unique_id_93FyfigtTdTcMeta?.path ?? "/invitation/:invitation_unique_id()",
    meta: _91invitation_unique_id_93FyfigtTdTcMeta || {},
    alias: _91invitation_unique_id_93FyfigtTdTcMeta?.alias || [],
    redirect: _91invitation_unique_id_93FyfigtTdTcMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/invitation/[invitation_unique_id].vue").then(m => m.default || m)
  },
  {
    name: joinSE9yISEi0kMeta?.name ?? "join",
    path: joinSE9yISEi0kMeta?.path ?? "/join",
    meta: joinSE9yISEi0kMeta || {},
    alias: joinSE9yISEi0kMeta?.alias || [],
    redirect: joinSE9yISEi0kMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/join.vue").then(m => m.default || m)
  },
  {
    name: login3tB2WDCkfOMeta?.name ?? "login",
    path: login3tB2WDCkfOMeta?.path ?? "/login",
    meta: login3tB2WDCkfOMeta || {},
    alias: login3tB2WDCkfOMeta?.alias || [],
    redirect: login3tB2WDCkfOMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/login.vue").then(m => m.default || m)
  },
  {
    name: logoutzMjzzXpcAeMeta?.name ?? "logout",
    path: logoutzMjzzXpcAeMeta?.path ?? "/logout",
    meta: logoutzMjzzXpcAeMeta || {},
    alias: logoutzMjzzXpcAeMeta?.alias || [],
    redirect: logoutzMjzzXpcAeMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/logout.vue").then(m => m.default || m)
  },
  {
    name: _91meeting_type_slug_93FZA77WTp3BMeta?.name ?? "meet-meeting_type_slug",
    path: _91meeting_type_slug_93FZA77WTp3BMeta?.path ?? "/meet/:meeting_type_slug()",
    meta: _91meeting_type_slug_93FZA77WTp3BMeta || {},
    alias: _91meeting_type_slug_93FZA77WTp3BMeta?.alias || [],
    redirect: _91meeting_type_slug_93FZA77WTp3BMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/meet/[meeting_type_slug].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93zmXWtjROmlMeta?.name ?? "meet-meeting_unique_id",
    path: _91meeting_unique_id_93zmXWtjROmlMeta?.path ?? "/meet/:meeting_unique_id()",
    meta: _91meeting_unique_id_93zmXWtjROmlMeta || {},
    alias: _91meeting_unique_id_93zmXWtjROmlMeta?.alias || [],
    redirect: _91meeting_unique_id_93zmXWtjROmlMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/meet/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93FdmxMYa9K9Meta?.name ?? "meeting-meeting_unique_id",
    path: _91meeting_unique_id_93FdmxMYa9K9Meta?.path ?? "/meeting/:meeting_unique_id()",
    meta: _91meeting_unique_id_93FdmxMYa9K9Meta || {},
    alias: _91meeting_unique_id_93FdmxMYa9K9Meta?.alias || [],
    redirect: _91meeting_unique_id_93FdmxMYa9K9Meta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/meeting/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: my_45favoritesDhiPb5S1bgMeta?.name ?? "my-favorites",
    path: my_45favoritesDhiPb5S1bgMeta?.path ?? "/my-favorites",
    meta: my_45favoritesDhiPb5S1bgMeta || {},
    alias: my_45favoritesDhiPb5S1bgMeta?.alias || [],
    redirect: my_45favoritesDhiPb5S1bgMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: my_45studiosdldqDB6zwUMeta?.name ?? "my-studios",
    path: my_45studiosdldqDB6zwUMeta?.path ?? "/my-studios",
    meta: my_45studiosdldqDB6zwUMeta || {},
    alias: my_45studiosdldqDB6zwUMeta?.alias || [],
    redirect: my_45studiosdldqDB6zwUMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/my-studios.vue").then(m => m.default || m)
  },
  {
    name: optinmKLWxXyr7RMeta?.name ?? "optin",
    path: optinmKLWxXyr7RMeta?.path ?? "/optin",
    meta: optinmKLWxXyr7RMeta || {},
    alias: optinmKLWxXyr7RMeta?.alias || [],
    redirect: optinmKLWxXyr7RMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/optin.vue").then(m => m.default || m)
  },
  {
    name: _91episode_id_93akjyir9FJZMeta?.name ?? "podcasts-podcast_id-episodes-episode_id",
    path: _91episode_id_93akjyir9FJZMeta?.path ?? "/podcasts/:podcast_id()/episodes/:episode_id()",
    meta: _91episode_id_93akjyir9FJZMeta || {},
    alias: _91episode_id_93akjyir9FJZMeta?.alias || [],
    redirect: _91episode_id_93akjyir9FJZMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue").then(m => m.default || m)
  },
  {
    name: indexISbOpBoVxGMeta?.name ?? "podcasts-podcast_id",
    path: indexISbOpBoVxGMeta?.path ?? "/podcasts/:podcast_id()",
    meta: indexISbOpBoVxGMeta || {},
    alias: indexISbOpBoVxGMeta?.alias || [],
    redirect: indexISbOpBoVxGMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/podcasts/[podcast_id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1aGRqnXKz0Meta?.name ?? "podcasts",
    path: index1aGRqnXKz0Meta?.path ?? "/podcasts",
    meta: index1aGRqnXKz0Meta || {},
    alias: index1aGRqnXKz0Meta?.alias || [],
    redirect: index1aGRqnXKz0Meta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/podcasts/index.vue").then(m => m.default || m)
  },
  {
    name: _91product_id_933hn8GCyqCAMeta?.name ?? "product-product_id",
    path: _91product_id_933hn8GCyqCAMeta?.path ?? "/product/:product_id()",
    meta: _91product_id_933hn8GCyqCAMeta || {},
    alias: _91product_id_933hn8GCyqCAMeta?.alias || [],
    redirect: _91product_id_933hn8GCyqCAMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: abouts563UZgXcMMeta?.name ?? "product-product_id-about",
    path: abouts563UZgXcMMeta?.path ?? "about",
    meta: abouts563UZgXcMMeta || {},
    alias: abouts563UZgXcMMeta?.alias || [],
    redirect: abouts563UZgXcMMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: digital_45download_45contentLSoxlXRF8TMeta?.name ?? "product-product_id-digital-download-content",
    path: digital_45download_45contentLSoxlXRF8TMeta?.path ?? "digital-download-content",
    meta: digital_45download_45contentLSoxlXRF8TMeta || {},
    alias: digital_45download_45contentLSoxlXRF8TMeta?.alias || [],
    redirect: digital_45download_45contentLSoxlXRF8TMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/digital-download-content.vue").then(m => m.default || m)
  },
  {
    name: eventsCF8fPhCj6SMeta?.name ?? "product-product_id-events",
    path: eventsCF8fPhCj6SMeta?.path ?? "events",
    meta: eventsCF8fPhCj6SMeta || {},
    alias: eventsCF8fPhCj6SMeta?.alias || [],
    redirect: eventsCF8fPhCj6SMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93jA3HLRpUExMeta?.name ?? "product-product_id-free-media-media_id",
    path: _91media_id_93jA3HLRpUExMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93jA3HLRpUExMeta || {},
    alias: _91media_id_93jA3HLRpUExMeta?.alias || [],
    redirect: _91media_id_93jA3HLRpUExMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sample0JDGB0sJnpMeta?.name ?? "product-product_id-free-sample",
    path: free_45sample0JDGB0sJnpMeta?.path ?? "free-sample",
    meta: free_45sample0JDGB0sJnpMeta || {},
    alias: free_45sample0JDGB0sJnpMeta?.alias || [],
    redirect: free_45sample0JDGB0sJnpMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsIerZ8N8BGBMeta?.name ?? "product-product_id-included-products",
    path: included_45productsIerZ8N8BGBMeta?.path ?? "included-products",
    meta: included_45productsIerZ8N8BGBMeta || {},
    alias: included_45productsIerZ8N8BGBMeta?.alias || [],
    redirect: included_45productsIerZ8N8BGBMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93q9VUbYM5FlMeta?.name ?? "product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93q9VUbYM5FlMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93q9VUbYM5FlMeta || {},
    alias: _91media_id_93q9VUbYM5FlMeta?.alias || [],
    redirect: _91media_id_93q9VUbYM5FlMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: view5C6bzcETEnMeta?.name ?? "product-product_id-lessons-lesson_id-view",
    path: view5C6bzcETEnMeta?.path ?? "lessons/:lesson_id()/view",
    meta: view5C6bzcETEnMeta || {},
    alias: view5C6bzcETEnMeta?.alias || [],
    redirect: view5C6bzcETEnMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indextWWLWL6uI5Meta?.name ?? "product-product_id-lessons",
    path: indextWWLWL6uI5Meta?.path ?? "lessons",
    meta: indextWWLWL6uI5Meta || {},
    alias: indextWWLWL6uI5Meta?.alias || [],
    redirect: indextWWLWL6uI5Meta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93WMh4oSTSSUMeta?.name ?? "product-product_id-media-media_id",
    path: _91media_id_93WMh4oSTSSUMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93WMh4oSTSSUMeta || {},
    alias: _91media_id_93WMh4oSTSSUMeta?.alias || [],
    redirect: _91media_id_93WMh4oSTSSUMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexIeGmuNwCa5Meta?.name ?? "product-product_id-playlists-playlist_id",
    path: indexIeGmuNwCa5Meta?.path ?? "playlists/:playlist_id()",
    meta: indexIeGmuNwCa5Meta || {},
    alias: indexIeGmuNwCa5Meta?.alias || [],
    redirect: indexIeGmuNwCa5Meta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93ZoVXRcyOigMeta?.name ?? "product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93ZoVXRcyOigMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93ZoVXRcyOigMeta || {},
    alias: _91media_id_93ZoVXRcyOigMeta?.alias || [],
    redirect: _91media_id_93ZoVXRcyOigMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexRXTstQ1RRoMeta?.name ?? "product-product_id-playlists",
    path: indexRXTstQ1RRoMeta?.path ?? "playlists",
    meta: indexRXTstQ1RRoMeta || {},
    alias: indexRXTstQ1RRoMeta?.alias || [],
    redirect: indexRXTstQ1RRoMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsNMjTq8nTCJMeta?.name ?? "product-product_id-private-sessions",
    path: private_45sessionsNMjTq8nTCJMeta?.path ?? "private-sessions",
    meta: private_45sessionsNMjTq8nTCJMeta || {},
    alias: private_45sessionsNMjTq8nTCJMeta?.alias || [],
    redirect: private_45sessionsNMjTq8nTCJMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsGdLH5CvPcrMeta?.name ?? "product-product_id-recordings",
    path: recordingsGdLH5CvPcrMeta?.path ?? "recordings",
    meta: recordingsGdLH5CvPcrMeta || {},
    alias: recordingsGdLH5CvPcrMeta?.alias || [],
    redirect: recordingsGdLH5CvPcrMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsUzdjHfJqfKMeta?.name ?? "product-product_id-reviews",
    path: reviewsUzdjHfJqfKMeta?.path ?? "reviews",
    meta: reviewsUzdjHfJqfKMeta || {},
    alias: reviewsUzdjHfJqfKMeta?.alias || [],
    redirect: reviewsUzdjHfJqfKMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexidNo0CbkiHMeta?.name ?? "product",
    path: indexidNo0CbkiHMeta?.path ?? "/product",
    meta: indexidNo0CbkiHMeta || {},
    alias: indexidNo0CbkiHMeta?.alias || [],
    redirect: indexidNo0CbkiHMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/product/index.vue").then(m => m.default || m)
  },
  {
    name: indexaqR0BUg2TgMeta?.name ?? "profile",
    path: indexaqR0BUg2TgMeta?.path ?? "/profile",
    meta: indexaqR0BUg2TgMeta || {},
    alias: indexaqR0BUg2TgMeta?.alias || [],
    redirect: indexaqR0BUg2TgMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/profile/index.vue").then(m => m.default || m)
  },
  {
    name: purchasesyk1fo2tlyjMeta?.name ?? "profile-purchases",
    path: purchasesyk1fo2tlyjMeta?.path ?? "/profile/purchases",
    meta: purchasesyk1fo2tlyjMeta || {},
    alias: purchasesyk1fo2tlyjMeta?.alias || [],
    redirect: purchasesyk1fo2tlyjMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/profile/purchases.vue").then(m => m.default || m)
  },
  {
    name: redemptionsF2WlTsaLORMeta?.name ?? "profile-redemptions",
    path: redemptionsF2WlTsaLORMeta?.path ?? "/profile/redemptions",
    meta: redemptionsF2WlTsaLORMeta || {},
    alias: redemptionsF2WlTsaLORMeta?.alias || [],
    redirect: redemptionsF2WlTsaLORMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/profile/redemptions.vue").then(m => m.default || m)
  },
  {
    name: _91quiz_id_93xFRibBwJDsMeta?.name ?? "quiz-quiz_id",
    path: _91quiz_id_93xFRibBwJDsMeta?.path ?? "/quiz/:quiz_id()",
    meta: _91quiz_id_93xFRibBwJDsMeta || {},
    alias: _91quiz_id_93xFRibBwJDsMeta?.alias || [],
    redirect: _91quiz_id_93xFRibBwJDsMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/quiz/[quiz_id].vue").then(m => m.default || m)
  },
  {
    name: _91token_93R6t244Zaq4Meta?.name ?? "reset-password-uid-token",
    path: _91token_93R6t244Zaq4Meta?.path ?? "/reset-password/:uid()/:token()",
    meta: _91token_93R6t244Zaq4Meta || {},
    alias: _91token_93R6t244Zaq4Meta?.alias || [],
    redirect: _91token_93R6t244Zaq4Meta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/reset-password/[uid]/[token].vue").then(m => m.default || m)
  },
  {
    name: resetbFElebpWOtMeta?.name ?? "reset",
    path: resetbFElebpWOtMeta?.path ?? "/reset",
    meta: resetbFElebpWOtMeta || {},
    alias: resetbFElebpWOtMeta?.alias || [],
    redirect: resetbFElebpWOtMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/reset.vue").then(m => m.default || m)
  },
  {
    name: shopXuM9FK4QYeMeta?.name ?? "shop",
    path: shopXuM9FK4QYeMeta?.path ?? "/shop",
    meta: shopXuM9FK4QYeMeta || {},
    alias: shopXuM9FK4QYeMeta?.alias || [],
    redirect: shopXuM9FK4QYeMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/shop.vue").then(m => m.default || m)
  },
  {
    name: signupv76RDVr3aXMeta?.name ?? "signup",
    path: signupv76RDVr3aXMeta?.path ?? "/signup",
    meta: signupv76RDVr3aXMeta || {},
    alias: signupv76RDVr3aXMeta?.alias || [],
    redirect: signupv76RDVr3aXMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/signup.vue").then(m => m.default || m)
  },
  {
    name: liveX2TB1qcnxsMeta?.name ?? "streaming-event_id-live",
    path: liveX2TB1qcnxsMeta?.path ?? "/streaming/:event_id()/live",
    meta: liveX2TB1qcnxsMeta || {},
    alias: liveX2TB1qcnxsMeta?.alias || [],
    redirect: liveX2TB1qcnxsMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/streaming/[event_id]/live.vue").then(m => m.default || m)
  },
  {
    name: tipsDfRfoIHc0cMeta?.name ?? "tips",
    path: tipsDfRfoIHc0cMeta?.path ?? "/tips",
    meta: tipsDfRfoIHc0cMeta || {},
    alias: tipsDfRfoIHc0cMeta?.alias || [],
    redirect: tipsDfRfoIHc0cMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/tips.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93lJxQ6r5eMTMeta?.name ?? "waiver-uuid",
    path: _91uuid_93lJxQ6r5eMTMeta?.path ?? "/waiver/:uuid()",
    meta: _91uuid_93lJxQ6r5eMTMeta || {},
    alias: _91uuid_93lJxQ6r5eMTMeta?.alias || [],
    redirect: _91uuid_93lJxQ6r5eMTMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/waiver/[uuid].vue").then(m => m.default || m)
  },
  {
    name: compactMhNp1iPZHCMeta?.name ?? "widgets-calendars-compact",
    path: compactMhNp1iPZHCMeta?.path ?? "/widgets/calendars/compact",
    meta: compactMhNp1iPZHCMeta || {},
    alias: compactMhNp1iPZHCMeta?.alias || [],
    redirect: compactMhNp1iPZHCMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/widgets/calendars/compact.vue").then(m => m.default || m)
  },
  {
    name: full9YOWqpyVHPMeta?.name ?? "widgets-calendars-full",
    path: full9YOWqpyVHPMeta?.path ?? "/widgets/calendars/full",
    meta: full9YOWqpyVHPMeta || {},
    alias: full9YOWqpyVHPMeta?.alias || [],
    redirect: full9YOWqpyVHPMeta?.redirect,
    component: () => import("/tmp/build_b5bbee9d/pages/[studio_url]/widgets/calendars/full.vue").then(m => m.default || m)
  }
]